import { CustomEpic, PayloadAction, AppointmentStatusName } from 'types/types';
import {
  UpdateAppointmentActionPayload,
  updateAppointmentFailure,
  updateAppointmentSuccess,
} from 'modules/appointments/actions';
import { ofType } from 'redux-observable';
import { UPDATE_APPOINTMENT } from 'modules/appointments/actionTypes';
import { switchMap } from 'rxjs/operators';
import { getUpdateAppointmentUrl } from 'modules/appointments/utils/getUpdateAppointmentUrl';
import { denormalizeAppointment } from 'modules/appointments/utils/normalizeAppointment';
import { handleAjaxSuccess } from 'utils/epics/handleAjaxSuccess';
import { updateAppointmentCallTranslator } from 'modules/appointments/translator';
import { handleAjaxError } from 'utils/epics/handleAjaxError';
import { getAuthHeaders } from 'api/getAuthHeaders';
import { getCurrentConnectionStatus } from 'utils/connectionStatus';
import { handleOfflineArrival } from 'modules/offlineSync/utils/handleOfflineArrival';

export const updateAppointment$: CustomEpic<UpdateAppointmentActionPayload> = (
  action$,
  state$,
  { postApi$ },
) =>
  action$.pipe(
    ofType(UPDATE_APPOINTMENT),
    switchMap((action: PayloadAction<UpdateAppointmentActionPayload>) => {
      const { id, ...rest } = action.payload;

      // Offline guard for session arrival
      if (
        getCurrentConnectionStatus() === 'offline' &&
        rest.appStatus === AppointmentStatusName.Arrived
      ) {
        return handleOfflineArrival(id, rest, state$);
      }

      return postApi$({
        endpoint: getUpdateAppointmentUrl({ appointmentId: id }),
        headers: getAuthHeaders(state$.value),
        payload: denormalizeAppointment(rest),
      }).pipe(
        handleAjaxSuccess(
          updateAppointmentSuccess,
          updateAppointmentCallTranslator,
        ),
        handleAjaxError(updateAppointmentFailure),
      );
    }),
  );
